<template>
  <div style="height: 99%;text-align: left">
    <!-- 搜索栏 -->
    <el-form ref="formName" :inline="true" :model="queryParams" class="demo-form-inline" style="margin-left: 10px">
      <el-form-item label="申请日期" prop="startTime" style="margin-left: 10px">
        <el-date-picker
          v-model="queryParams.startTime"
          type="date"
          size="small"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="width: 130px"
        >
        </el-date-picker>

      </el-form-item>
      <el-form-item label="至" prop="endTime">
        <el-date-picker
          v-model="queryParams.endTime"
          type="date"
          size="small"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="width: 130px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="billNumber">
        <el-input
          v-model="queryParams.billNumber"
          placeholder="单据号"
          clearable
          size="small"
          style="width: 150px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-row style="height: calc(100% - 80px);">
      <el-table
        class="tableClass"
        :data="tableData"
        height="calc(100%)"
        size="small"
        style="margin-left: 10px"
        border
        :header-cell-style=" {background:'#F8FCFF',color:'#606266'}">
        <el-table-column label="序号" align="center" type="index" :index="Nindex" width="50" />
        <el-table-column label="申请日期" header-align="center" align="left" prop="applicationDate" width="100" :formatter="rqFormatter" />
        <el-table-column label="单据号" header-align="center" align="left" prop="billNumber" width="110" />
        <el-table-column label="单据类别" header-align="center" align="left" prop="billCategory" width="100" />
        <el-table-column label="申请人" header-align="center" align="left" prop="applyPerson" width="80" />
        <el-table-column v-if="applyPersonId" label="申请人id" header-align="center" align="left" prop="applyPersonId" />
        <el-table-column label="申请原因" header-align="center" align="left" prop="applyReason" width="100" />
        <el-table-column v-if="ccsqd" label="出差申请单" header-align="center" align="left" prop="ccsqd" width="100" />
        <el-table-column label="申请金额" header-align="center" align="right" prop="applyMoney" width="150" />
        <el-table-column label="具体事宜" header-align="center" align="left" prop="specificMatters" :show-overflow-tooltip="true" />
        <el-table-column label="状态" header-align="center" align="center" prop="bxbz" width="120">
          <template slot-scope="scope">
            <span style="color: #5FB878">{{ scope.row.bxbz === '1' ? '已填制报销单' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" prop="orderCount" fixed="right" width="100">
          <template slot-scope="operate">
            <el-link type="primary" :underline="false" style="margin-right: 5px;font-size: 12px" @click="seeSqd(operate.row)">查看</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-pagination
      :current-page="queryParams.currentPage"
      :page-sizes="[100,200]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>


    <addCcsqd
      :no-save="noSave"
      :view="view"
      :add-ccsqd-view="addCcsqdView"
      :add-ccsqd-data="addCcsqdData"
      :sh-data="shData"
      :colse-ccsqd="colseCcsqd"
    ></addCcsqd>

    <add-fysq
      v-if="addFysqdView"
      :show-bol="showBol"
      :view="view"
      :sh-data="shData"
      :add-fysqd-data="addFysqdData"
      @colseFysqd="colseFysqd"
    ></add-fysq>


  </div>
</template>

<script>
import AddCcsqd from '../applicationToDO/addCcsqd'
import addFysq from '../applicationToDO/addFysq'
import publicBuill from '../../../components/reimbursement/js/publicBuill'
export default {
  name: 'completedXsSqd',
  // eslint-disable-next-line vue/no-unused-components
  components: { AddCcsqd, addFysq },
  data() {
    return {
      applyPersonId: false,
      ccsqd: false,
      tableData: [],
      total: 0,
      noSave: false,
      view: '',
      addCcsqdView: false,
      addFysqdView: false,
      showBol: [true],
      addCcsqdData: {},
      addFysqdData: {},
      shData: [],
      queryParams: {
        currentPage: 1,
        pageSize: 100,
        billNumber: undefined,
        startTime: undefined,
        endTime: undefined
      },
      djhs: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    Nindex(index) {
      const page = this.queryParams.currentPage
      const pageSize = this.queryParams.pageSize
      return index + 1 + (page - 1) * pageSize
    },
    rqFormatter(row, column) {
      const time = row[column.property]
      return time.split(' ')[0] // 提取时间部分
    },
    //查询列表数据
    getList() {
      const loading = this.$loading({
        lock: true,
        text: '查询中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(51,48,48,0.7)'
      })
      const data = {
        currentPage: this.queryParams.currentPage,
        limit: this.queryParams.pageSize,
        billNumber: this.queryParams.billNumber,
        starttime: this.queryParams.startTime,
        endtime: this.queryParams.endTime,
        shr: localStorage.getItem('userName')
      }
      this.$post('/fesback/XsDocument/completedXsSqdList.z', data).then(res => {
        console.log(res.data.data)
        this.tableData = res.data.data
        this.tableData.forEach(value => {
          value.applyMoney = publicBuill.formatAmount(Number(value.applyMoney).toFixed(2))
        })
        this.total = res.data.count
        loading.close()
      })
    },
    //搜索
    handleQuery() {
      this.queryParams.currentPage = 1
      this.getList()
    },
    handleSizeChange(val) { // 每页多少条
      this.queryParams.pageSize = val
      this.getList()
    },
    /* table */
    handleCurrentChange(val) {
      this.queryParams.currentPage = val
      this.getList()
    },
    //查看申请单
    seeSqd(row) {
      const djh = row.billNumber.substring(0, 2)
      if (djh === 'CS') {
        const data = {
          billNumber: row.billNumber
        }
        this.$post('/fesback/XsDocument/getCcSqdByDjh.z', data).then(res => {
          this.addCcsqdData = res.data.data[0]
          this.addCcsqdData.applyDate = res.data.data[0].applyDate.split(' ')[0]
          this.addCcsqdData.operator = res.data.data[0].lrr
          this.view = 'see'
          this.noSave = false
          this.addCcsqdView = true
        })
        const shData = {
          maindjh: row.billNumber
        }
        this.$post('/fesback/XsDocument/getShByDjh.z', shData).then(request => {
          this.shData = request.data.data
        })
      } else {
        var data = {
          djh: row.billNumber
        }
        this.$post('/fesback/XsDocument/getFySqdByDjh.z', data).then(res => {
          this.addFysqdData = res.data.data[0]
          this.addFysqdData.rq = res.data.data[0].rq.split(' ')[0]
          this.addFysqdData.operator = res.data.data[0].lrr
          this.handleInputChange(res.data.data[0].je.toString())
          this.addFysqdData.je = publicBuill.formatAmount(Number(res.data.data[0].je).toFixed(2))
          this.noSave = false
          this.view = 'see'
          this.addFysqdView = true
        })
        const shData = {
          maindjh: row.billNumber
        }
        this.$post('/fesback/XsDocument/getShByDjh.z', shData).then(request => {
          this.shData = request.data.data
        })
      }
    },
    colseCcsqd() {
      this.addCcsqdView = false
      this.addCcsqdData = {}
    },
    colseFysqd() {
      this.addFysqdView = false
      this.addFysqdData = {}
    },
    //监听金额数据，更改金额大写
    handleInputChange(money) {
      var ss = money.replace(/[^\d.]/g, '')
      var reg = /^[0-9]+\.?[0-9]*?$/
      if (!reg.test(ss)) {
        this.addFysqdData.je = ''
        money = ''
      }
      let i
      var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] //汉字的数字
      var cnIntRadice = ['', '拾', '佰', '仟'] //基本单位
      var cnIntUnits = ['', '万', '亿', '兆'] //对应整数部分扩展单位
      var cnDecUnits = ['角', '分', '毫', '厘'] //对应小数部分单位
      var cnInteger = '整' //整数金额时后面跟的字符
      var cnIntLast = '元' //整型完以后的单位
      var maxNum = 999999999999999.9999 //最大处理的数字
      var IntegerNum //金额整数部分
      var DecimalNum //金额小数部分
      var ChineseStr = '' //输出的中文金额字符串
      var parts //分离金额后用的数组，预定义
      var Symbol = ''//正负值标记
      if (money === '') {
        this.addFysqdData.dxje = ''
        return ''
      }
      money = parseFloat(money)
      if (money >= maxNum) {
        alert('超出最大处理数字')
        return ''
      }
      if (money === 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger
        return ChineseStr
      }
      if (money < 0) {
        money = -money
        Symbol = '负 '
      }
      money = money.toString() //转换为字符串
      if (money.indexOf('.') === -1) {
        IntegerNum = money
        DecimalNum = ''
      } else {
        parts = money.split('.')
        IntegerNum = parts[0]
        DecimalNum = parts[1].substr(0, 4)
      }
      if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
        var zeroCount = 0
        var IntLen = IntegerNum.length
        for (i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1)
          var p = IntLen - i - 1
          var q = p / 4
          var m = p % 4
          if (n === '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0]
            }
            zeroCount = 0 //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }
          if (m === 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q]
          }
        }
        ChineseStr += cnIntLast
        //整型部分处理完毕
      }
      if (DecimalNum !== '') { //小数部分
        var decLen = DecimalNum.length
        for (i = 0; i < decLen; i++) {
          var as = DecimalNum.substr(i, 1)
          if (as !== '0') {
            ChineseStr += cnNums[Number(as)] + cnDecUnits[i]
          }
        }
      }
      if (ChineseStr === '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger
      } else if (DecimalNum === '') {
        ChineseStr += cnInteger
      }
      this.addFysqdData.dxje = Symbol + ChineseStr
    }
  }
}
</script>

<style scoped lang="scss">
.el-pagination {
  margin-left: 20px;
  margin-top: 10px;
}
.demo-form-inline {
  height: 45px;
}
</style>
